import { render, staticRenderFns } from "./TableControl.vue?vue&type=template&id=0c55e2e4"
import script from "./TableControl.vue?vue&type=script&lang=js"
export * from "./TableControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports